import React, { useState } from "react";
import PdfFlatList from "./PdfFlatList";
import GoogleSlidesFlatList from "./GoogleSlidesFlatList";

const SlidekickOnly = ({
  slidekick_url,
  active_slide,
  set_active_slide,
  deck_size,
  slide_type,
}) => {
  const [swiper, setSwiper] = useState(null);
  return (
    <div className="slidekick-presenting-container">
      <div className="slidekick-main-content">
        {slide_type === "pdf" ? (
          <PdfFlatList
            url={slidekick_url}
            swiper={swiper}
            setSwiper={setSwiper}
            active_slide={active_slide}
            set_active_slide={set_active_slide}
            total_pages={deck_size}
          />
        ) : (
          <GoogleSlidesFlatList
            url={slidekick_url}
            swiper={swiper}
            setSwiper={setSwiper}
            active_slide={active_slide}
            set_active_slide={set_active_slide}
            total_pages={deck_size}
          />
        )}
      </div>
    </div>
  );
};

export default SlidekickOnly;
